module.exports = __webpack_public_path__ + "static/media/Chapter 3 Slide 4.0ef1811b.jpg";